export default __webpack_public_path__ + "static/media/eggcelent.91c2beac.jpg";